import React from "react";
import styles from "../styles/PageLayout.module.css";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

export function PageState({ tone = "neutral", title, description }) {
  return (
    <div
      className={joinClasses(
        styles.pageState,
        tone === "error" && styles.pageStateError,
        tone === "empty" && styles.pageStateEmpty
      )}
    >
      <strong>{title}</strong>
      {description ? <div>{description}</div> : null}
    </div>
  );
}

export default PageState;
